import { borderRadius, fontSize, height, width } from "@mui/system";

const constants = {
    styles: {
        mainButton: {
            textTransform: 'none',
            border: '1px solid #0102CE',
            backgroundColor: '#CBE3FF',
            color: '#0102CE',
            width: '100%',
            height: '45px',
            boxShadow: 3,
            borderRadius: 2
        },
        secondaryButton: {
            textTransform: 'none',
            border: '1px solid #0102CE',
            backgroundColor: '#ffffff',
            color: '#0102CE',
            width: '100%',
            height: '45px',
            boxShadow: 3,
            borderRadius: 2
        },
        specialButton: {
            textTransform: 'none',
            border: '1px solid #0102CE',
            backgroundColor: '#0102CE',
            color: '#ffffff',
            width: '100%',
            height: '35px',
            boxShadow: 3,
            borderRadius: 2
        },
        linkButton: {
            textTransform: 'none',
            color: '#0102CE'
        },
        textfield: {
            fontSize: 10,
            margin: '0',
            width: '100%'
        },
        modalBox: {
            position: 'absolute',
            padding: 0, 
            //display: 'flex',
            // flexGrow: 1,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            boxShadow: 24,
            borderRadius: 3
        }
    }
}

export default constants;
